import { useAppSelector } from 'hooks/hooks';
import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { Report } from 'types/reports';

type Props = {
  styles: any;
  handleReport: (approve: boolean, report: Report) => void;
};

export function EditUserReports({ styles, handleReport }: Props) {
  const reports = useAppSelector((state) => state.reports);
  return (
    <View>
      {reports ? (
        reports.value.map((report, index) => (
          <View key={report.id} style={[styles.row]}>
            <View>
              <Text style={styles.subtitle}>
                {index + 1}. {report.priority}
              </Text>
              <Text>{report.description}</Text>
              {report.latlng && <Text>{report.latlng}</Text>}
              {report.contact && report.contact !== 'null' && (
                <Text>{report.contact}</Text>
              )}
            </View>
            <View style={styles.inlineButtonContainer}>
              <Pressable onPress={() => handleReport(true, report)}>
                <Text style={[styles.inlineButton, styles.success]}>
                  Approve
                </Text>
              </Pressable>
              <Pressable onPress={() => handleReport(false, report)}>
                <Text style={[styles.inlineButton, styles.error]}>Remove</Text>
              </Pressable>
            </View>
          </View>
        ))
      ) : (
        <Text style={styles.buttonContainer}>No reports</Text>
      )}
    </View>
  );
}
